import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { FormaPagamentoAtualizar, FormaPagamentoCadastrar } from '../../../../routes/RoutesNames';
import { useSelector } from 'react-redux';
import FormaPagamentoController from '../../../../controllers/FormaPagamentoController';
import { toast } from 'react-toastify';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu'
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  fpg_id: number;
  fpg_descricao: string;
  tpg_id: number;
  fpg_tipo_utilizacao: string;
  fpg_tipo_cartao: number;
  fpg_taxa_minima: string;
  fpg_taxa_transacao_avista: number;
  fpg_quantidade_dias_recebimento: string;
}

export default function FormaPagamento() {
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();

  const tableColumns: Column[] = [
    { id: 'Id', label: 'Id', minWidth: 0, align: 'center' },
    { id: 'Descricao', label: 'Descrição', minWidth: 0, align: 'center' },
    { id: 'TpgId', label: 'Tipo Pagamento', minWidth: 0, align: 'center' },
    { id: 'Utilizacao', label: 'Utilização', minWidth: 0, align: 'center' },
    { id: 'Cartao', label: 'Cartão', minWidth: 0, align: 'center' },
    { id: 'TxMinima', label: 'Taxa Mínima', minWidth: 0, align: 'center' },
    { id: 'TxAVista', label: 'Taxa À Vista', minWidth: 0, align: 'center' },
    { id: 'QntdDiasReceb', label: 'Qtd Dias Recebimento', minWidth: 0, align: 'center' },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];
  const fields = [
    { name: 'FormaPagamentoId', label: 'Código', type: 'number', col: 3 },
    { name: 'Descricao', label: 'Descrição', type: 'text', col: 3 },
    { name: 'TipoPagamentoId', label: 'Tipo Pagamento', type: 'text', col: 3 },
    { name: 'TipoUtilizacao', label: 'Utilização', type: 'text', col: 3 },
    { name: 'TipoCartao', label: 'Cartão', type: 'text', col: 3 },
    { name: 'TaxaMinima', label: 'Taxa Mínima', type: 'text', col: 3 },
    { name: 'TaxaTransAVista', label: 'Taxa de Transação à vista', type: 'text', col: 3 },
    { name: 'QntdDiasRecebimento', label: 'Quantidade de Dias Para Recebimento', type: 'text', col: 2 },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />), col: 1 }
  ];
  const [tableRows, setTableRows] = useState<Row[]>([]);
  const initialValues = {
    FormaPagamentoId: null,
    Descricao: '',
    TipoPagamentoId: '',
    TipoUtilizacao: '',
    TipoCartao: '',
    TaxaMinima: '',
    TaxaTransAVista: '',
    QntdDiasRecebimento: '',
  };

  const handleNavigation = async (): Promise<void> => {
    navigate(FormaPagamentoCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(FormaPagamentoAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(FormaPagamentoAtualizar.replace(':id', item.fpg_id.toString()));
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    const Response = await FormaPagamentoController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          Id: item.fpg_id,
          Descricao: item.fpg_descricao,
          TpgId: item.tpg_id,
          Utilizacao: item.fpg_tipo_utilizacao,
          Cartao: item.fpg_tipo_cartao,
          TxMinima: item.fpg_taxa_minima,
          TxAVista: item.fpg_taxa_transacao_avista,
          QntdDiasReceb: item.fpg_quantidade_dias_recebimento,
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: "Editar" },
                { onClick: () => handleDeleteItem(item.fpg_id), menu: "Excluir", confirmar: `Excluir a forma de pagamento "${item.fpg_descricao ?? ''}"? Esta ação não pode ser desfeita.` },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'error',
      });
    }
  };

  const handleDeleteItem = async (fpg_id: number) => {
    const request: any = { UsuId: userId, FormaPagamentoId: fpg_id };
    const response = await FormaPagamentoController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Forma de Pagamento excluído com sucesso!', {
        type: 'success',
      });
      await handleSubmit(initialValues)
    } else {
      toast('Erro ao excluir a forma de pagamento!', {
        type: 'error',
      });
    }
  }

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return (
    <Box>
      <HeaderComponent
        text={'Formas de Pagamento'}
        ButtonRight={
          <Button
            className={''}
            variant='success'
            onClick={handleNavigation}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} gap='gap-3' />
      <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);}} />
    </Box>
  );
}
